//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";
import { requiredAddressValidation } from "@Shared/@Utils/validation-rules";
import AddressSection from "@Shared/components/sections/new-sections/address-section.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import Field from "@Shared/components/sections/field.vue";
import PhoneInput from "@Shared/components/inputs/phone-input.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SubmissionAgent",
  components: {
    AddressSection,
    MaterialInput,
    Field,
    PhoneInput
  },
  mixins: [validationMixin],
  props: {
    submissionAgent: {
      type: Object,
      required: true
    }
  },
  validations: {
    editingAgent: {
      givenName: {
        required
      },
      familyName: {
        required
      },
      email: {
        required,
        email
      },
      phoneNumber: {
        required
      },
      firmCode: {
        required
      },
      expertProfileNumber: {
        required
      },
      address: requiredAddressValidation()
    }
  },
  data() {
    return {
      editingAgent: {}
    };
  },
  computed: {
    addressCustomExpressions() {
      return {
        line1: "editingAgent.address.line1",
        "street-number": "editingAgent.address.street-number",
        "street-name": "editingAgent.address.street-name",
        city: "editingAgent.address.city",
        province: "editingAgent.address.province",
        "postal-code": "editingAgent.address.postal-code"
      };
    }
  },
  watch: {
    submissionAgent: {
      immediate: true,
      handler(value) {
        this.editingAgent = value;
      }
    }
  },
  methods: {
    handleSubmit() {
      const type = this.editingAgent.submissionAgentId ? "edit" : "add";
      this.$emit(type, this.editingAgent, this.$refs.submitButton);
    }
  }
});